export default "__VITE_ASSET__8d811e8d__"